<template>
  <div class="h-[500px]">
    <!-- Dashboard -->
    <StepTwoDashboard
      :orderCount="List.length"
      :totalAmount="totalAmount"
      :totalVehicles="totalRequimentVehicleCount"
    />
     <AddCustomerModal
      modal-name="add-customer-modal"
      @formSubmitted="handleCustomerFormSubmitted"
      :customerName="selected?.customer"
    />
    
    <div class="p-5 overflow-y-auto h-full xl:pb-1 pb-10">
      <div
        class="shadow h-96 overflow-x-scroll border border-gray-200 bg-white dark:bg-gray-900 rounded-xl"
      >
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
            <tr>
              <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 tracking-wide">
                Sipariş
              </th>
              <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 tracking-wide">
                Müşteri
              </th>
              <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 tracking-wide">
                Miktar
              </th>
              <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 tracking-wide">
                Rota
              </th>
              <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 tracking-wide">
                Araç Türü
              </th>
              <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 tracking-wide">
                Araç
              </th>
              <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 tracking-wide">
                Tür
              </th>
              <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 tracking-wide">
                Mesafe
              </th>
              <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 tracking-wide">
                Tarih
              </th>
              <th class="px-3 py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-400 tracking-wide w-20">
                
              </th>
            </tr>
          </thead>
          <tbody class="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
            <!-- Add new order row -->
            <NewOrderRow
              :loading="load"
              @add-order="handleAddOrder"
              @reset="resetNewOrderForm"
              ref="newOrderRow"
            />

            <!-- Order rows -->
            <OrderRow
              v-for="(order, index) in List"
              :key="index"
              :order="order"
              @delete="deleteItem"
            />
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
//Npm
import moment from "moment";

//Global Components
import orderInput from "@/components/devItem/orderInput.vue";
import diffInput from "@/components/general/diffInput.vue";
import StepTwoDashboard from "./stepTwo/StepTwoDashboard.vue";
import NewOrderRow from "./stepTwo/NewOrderRow.vue";
import OrderRow from "./stepTwo/OrderRow.vue";
import AddCustomerModal from "../../../../../control-panel/customers/components/add.modal.vue";
//Networking
import axios from "axios";
import { routeEngine } from "@/networking/routeEngine";
import { bulkShipPlanning } from "@/networking/urlmanager";

//Utils
import calculatorModel from "@/utils/vehecleCountRecomendation.js";

export default {
  name: "stepTwo",
  props: [
    "shipId", 
    "isAdd",
    "orderCount",
    "dates",
    "isLaterAddOrder",
    "minVehicleCount",
  ],
  components: {
    orderInput,
    diffInput,
    StepTwoDashboard,
    NewOrderRow,
    OrderRow,
    AddCustomerModal
  },
  data() {
    return {
      load: false,
      List: [],
      totalAmount: 0,
      totalRequimentVehicleCount: 0,
      orderId: "",
      selected: {
        amount: "",
        deliveryDate: "",
        targetAdress: "",
        customer: "",
        kilometer: "",
        recomendedCount: "",
        customerId:"",
      },
      routes: {},
    };
  },
  methods: {
    handleCustomerFormSubmitted(data) {
      this.selected.customerId=data.customerId;
      this.getRoute();
    },
    handleAddOrder(data) {
      this.orderId = data.orderId;
      this.selected = data.selected;
      if(data.selected.customerId==null || data.selected.customerId==undefined || data.selected.customerId==""){
        this.swalBox(
          "warning",
          "UYARI!",
         'Müşteri Kaydı Bulunmamaktadır.',
          false,
          "Tamam"
        ).then((result) => {
          if (result.isConfirmed) {
            this.$modal.show("add-customer-modal");
          }
          return;
        });
      }else{
        this.getRoute();
      }
    },
    resetNewOrderForm() {
      if (this.$refs.newOrderRow) {
        this.$refs.newOrderRow.resetForm();
      }
    },
    async calculateVehicleCount(totalMinute, deliveryDate, amount, orderDate) {
      const totalTonnage = amount;
      const loadPerVehicle = 26; // her bir aracın bir seferde taşıyabileceği yük miktar
      const maxDailyDrivingTime = 540;

      const { requiredVehicles, errorMessage } =
        await new calculatorModel().calculateRecomendedCount(
          orderDate,
          1,
          totalMinute,
          this.dates?.filling, //30, //this.fillingDate,
          this.dates?.delivery, //this.deliveryDate,
          deliveryDate,
          totalTonnage,
          loadPerVehicle,
          maxDailyDrivingTime,
          1 // normal calculate
        );

      if (errorMessage) {
        this.swalBox(
          "warning",
          "UYARI!",
          errorMessage,
          false,
          "Tamam"
        );
        return 1;
      }

      if (!Array.isArray(requiredVehicles)) {
        return requiredVehicles;
      }
      
      return 1;
    },
    getRoute() {
      if (this.orderId == "") {
        this.swalBox(
          "warning",
          "UYARI!",
          "LÜTFEN ÖNCE BİR SİPARİŞ SEÇİN...",
          false,
          "Tamam"
        );
        return;
      }
      const alreadyAdded = this.List.some(
        (item) => item.id === this.selected.id
      );
      if (alreadyAdded) {
        this.swalBox(
          "warning",
          "UYARI!",
          "Sipariş zaten listenize eklenmiş. Tekrar eklemek mümkün değil.",
          false,
          "Tamam"
        );
        return;
      }
      this.load = true;
      axios
        .post(
          routeEngine.generate,
          {
            from: {
              lat: Number(this.selected.outpointLat),
              lng: Number(this.selected.outpointLng),
            },
            to: {
              lat: Number(this.selected.targetPointLat),
              lng: Number(this.selected.targetPointLng),
            },
            fuelRatio: 35,
            isPolyline: 1,
            shippedHazardousGoods: 1,
            vehicleTypeId: 5,
            routeType: "fast",
            isApi: 1,
          },
          {
            headers: {
              Authorization: "Bareer " + this.$store.state.routeEngineToken,
            },
          }
        )
        .then((res) => {
          this.routes = res.data.data;
          this.addItem();
        })
        .catch((err) => {
          console.log(err);
          this.swalBox(
            "error",
            "HATA!",
            "Rota hesaplanırken bir hata oluştu.",
            false,
            "Tamam"
          );
        })
        .finally(() => {
          this.load = false;
        });
    },
    async addItem() {
      const data = this.routes;
      const kilometer = data.kilometer;
      const time = data.totalMinutes;
      const orderDate = this.selected.orderDate;

      const recomendedCount = await this.calculateVehicleCount(
        time,
        moment(this.selected.deliveryDate).format("YYYY-MM-DD HH:mm"),
        Number(this.selected.amount),
        orderDate
      );

      this.totalRequimentVehicleCount += recomendedCount;
      this.totalAmount += Number(this.selected.amount);

      this.List.push({
        ...this.selected,
        haveType: 3,
        kilometer: kilometer,
        time: time,
        recomendedCount,
        isStart: 1
      });

      this.resetItem();
      this.$emit("changeList", this.List);
    },
    resetItem() {
      this.orderId = "";
      this.selected = {
        amount: "",
        deliveryDate: "",
        targetAdress: "",
        customer: "",
        outpointAdress: "",
      };
      // Reset the NewOrderRow component form
      if (this.$refs.newOrderRow) {
        this.$refs.newOrderRow.resetForm();
      }
    },
    deleteItem(order) {
      this.swalBox(
        "warning",
        "UYARI!",
        "SİPARİŞİ LİSTEDEN ÇIKARMAK İSTEDİĞİNİZE EMİN MİSİNİZ?",
        true,
        "Evet"
      ).then((acc) => {
        if (acc.isConfirmed) {
          const index = this.List.findIndex(item => item.orderNo === order.orderNo);
          if (index > -1) {
            const itemToRemove = this.List[index];
            
            // Toplam araç sayısı ve miktardan çıkar
            this.totalRequimentVehicleCount = Math.max(0, this.totalRequimentVehicleCount - (itemToRemove.recomendedCount || 0));
            this.totalAmount = Math.max(0, this.totalAmount - (Number(itemToRemove.amount) || 0));
            
            // Listeden çıkar
            this.List.splice(index, 1);
            
            this.swalBox(
              "success",
              "BAŞARILI!",
              "Sipariş başarılı bir şekilde kaldırıldı...",
              false,
              "Tamam"
            );
            
            this.$emit("changeList", this.List);
          } else {
            this.swalBox(
              "warning",
              "HATA",
              "Sipariş kaldırılırken bir hata oluştu lütfen tekrar deneyin...",
              false,
              "Tamam"
            );
          }
        }
      });
    },
    updateTotals() {
      this.totalAmount = this.List.reduce((sum, order) => sum + (parseFloat(order.amount) || 0), 0);
      this.totalRequimentVehicleCount = this.List.reduce((sum, order) => sum + (order.recomendedCount || 1), 0);
    },
    async controller() {
      return new Promise((resolve, reject) => {
        const totalCalculatedVehicles = this.List.reduce(
          (sum, order) => sum + order.recomendedCount,
          0
        );

        const additionalVehiclesNeeded = Math.max(
          this.minVehicleCount - totalCalculatedVehicles,
          0
        );

        if (additionalVehiclesNeeded > 0) {
          this.swalBox(
            "warning",
            "UYARI!",
            "Araç sayısı otomatik olarak artırıldı: Operasyon için gereken minimum sayıya ulaşıldı.",
            false,
            "Tamam"
          )
            .then(() => {
              // Ek araçları siparişler arasında paylaştıralım
              this.distributeAdditionalVehicles(additionalVehiclesNeeded);
              resolve();
            })
            .catch((err) => {
              console.log(err);
              reject(err);
            });
        } else resolve();
      });
    },
    distributeAdditionalVehicles(additionalVehicles) {
      // Siparişleri miktarlarına göre sıralayalım (büyükten küçüğe)
      const sortedList = [...this.List].sort((a, b) => b.amount - a.amount);
      let remainingVehicles = additionalVehicles;
      let index = 0;
      while (remainingVehicles > 0 && index < sortedList.length) {
        sortedList[index].recomendedCount++;
        remainingVehicles--;
        index = (index + 1) % sortedList.length;
      }
      // Orijinal listeyi güncelleyelim
      this.List.forEach((order) => {
        const updatedOrder = sortedList.find((o) => o.id === order.id);
        order.recomendedCount = updatedOrder.recomendedCount;
      });
    },
    async save(callback) {
      if (this.List.length === 0) {
        this.swalBox(
          "warning",
          "UYARI!",
          "Lütfen ilk önce bir sipariş ekleyin!",
          false,
          "Tamam"
        );
        return callback(false);
      }

      await this.controller();
      
      // Save orders to database - same as ship module
      axios
        .post(
          bulkShipPlanning.orderAdd,
          {
            orders: JSON.stringify(this.List),
            shipId: this.shipId,
            isAdd: this.isAdd && this.orderCount > 0 ? 1 : 0,
          },
          {
            headers: {
              Authorization: "Bareer " + this.$store.state.userData.token,
            },
          }
        )
        .then(() => {
          this.swalBox(
            "success",
            "BAŞARILI!",
            "Siparişler başarıyla kaydedildi.",
            false,
            "Tamam"
          );
          callback(true);
        })
        .catch((err) => {
          this.errorBox(err.response);
          callback(false);
        });
    },
    swalBox(icon, title, text, showCancel, confirmText) {
      return this.$swal.fire({
        icon: icon,
        title: title,
        text: text,
        showCancelButton: showCancel,
        confirmButtonText: confirmText
      });
    },
    errorBox(error) {
      this.swalBox(
        "error",
        "HATA!",
        error?.data?.message || "Bir hata oluştu.",
        false,
        "Tamam"
      );
    }
  },
  watch: {
    List(val) {
      this.$emit("changeList", val);
    },
  },
  mounted() {
    // Initialize if needed
    this.updateTotals();
  }
};
</script>